<template>
	<div class="rightCon">
		<div class="connectStatus">
			<div class="subTitle">物联状态</div>
			<!-- 总台数 -->
			<div class="elvChartStatus">
				<div class="elvStatus">
					<div class="chartDes">
						<img :src="require('@/assets/elvInline.png')">
						<div class="chartDesNum">
							<div class="chartDesFont">在线电梯数量</div>
							<div class="numFont chartDesNumber">{{onlineStatus.onlineNum}}</div>
						</div>
					</div>
					<div class="chartDes">
						<img :src="require('@/assets/elvOffline.png')">
						<div class="chartDesNum">
							<div class="chartDesFont">离线电梯数量</div>
							<div class="numFont chartDesNumber">{{onlineStatus.offlineNum}}</div>
						</div>
					</div>
				</div>
				<div id="elvChart">
					<elvChart :onlineStatus="onlineStatus"></elvChart>
				</div>
			</div>
		</div>
		<div class="bindStatus">
			<div class="subTitle">绑定状态</div>
			<div class="bindRatio">
				<div class="ratioNumLine">
					<div class="ratioNum">
						<span class="numFont">{{bindRatio}}%</span>
						<span class="numFont">{{100-bindRatio}}%</span>
					</div>
					<div class="ratioLine">
						<div class="bindLine" :style="{width: bindRatio + '%'}">
							<div class="bindCircle"></div>
						</div>
						<div class="unBindLine" :style="{width: (100-bindRatio) + '%'}">
							<div class="unBindCircle"></div>
						</div>
					</div>
				</div>
				<div class="elvBind">
					<div class="bindElvNum elvNum">
						<img :src="require('@/assets/bind.png')">
						<div class="bindDes">
							<div class="bindLabel">已注册电梯数量</div>
							<div class="numFont">{{bindStatus.bindNums}}</div>
						</div>
					</div>
					<div class="unBindElvNum elvNum">
						<img :src="require('@/assets/unBind.png')">
						<div class="bindDes">
							<div class="bindLabel">未注册电梯数量</div>
							<div class="numFont">{{bindStatus.unbindNums}}</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="customerInfo">
			<div class="subTitle">客户信息</div>
			<div class="customer">
				<div>
					<img :src="require('@/assets/weibao.png')">
					<div class="customerName">维保企业</div>
					<div class="numFont weibaoNum">{{companyInfo.maintenanceNum ||0}}</div>
				</div>
				<div>
					<img :src="require('@/assets/wuye.png')">
					<div class="customerName">物业公司</div>
					<div class="numFont wuyeNum">{{companyInfo.propertyNum||0}}</div>
				</div>
				<div>
					<img :src="require('@/assets/community.png')">
					<div class="customerName">社区楼盘</div>
					<div class="numFont communityNum">{{companyInfo.communityNum||0}}</div>
				</div>
			</div>
		</div>
		<div class="timeContainer">
			<timeClock></timeClock>
		</div>
	</div>
</template>

<script>
import elvChart from "./echart/elvStatus.vue";
import timeClock from "@/components/timeClock.vue"
export default {
	components: { elvChart, timeClock },
	data() {
		return {
			onlineStatus: {},
			bindStatus: {
				bindNums: 0,
				unbindNums: 0
			},
			companyInfo: {},
			districtData: {}
		}
	},
	computed: {
		bindRatio() {
			return this.bindStatus.bindNums + this.bindStatus.unbindNums == 0 ?
				0 : (this.bindStatus.bindNums / (this.bindStatus.bindNums + this.bindStatus.unbindNums) * 100).toFixed(0)
		},

	},
	methods: {
		//物联状态
		getOnlineStatusData() {
			this.$api.onlineStatus(this.districtData).then(res => {
				if (res.errorCode == 0) {
					this.onlineStatus = res.data
				}
			})
		},
		//绑定状态
		getBindStatusData() {
			this.$api.bindStatus(this.districtData).then(res => {
				if (res.errorCode == 0) {
					this.bindStatus = res.data
				}
			})
		},
		//客户信息
		getCompanyInfo() {
			this.$api.companyInfo(this.districtData).then(res => {
				if (res.errorCode == 0) {
					this.companyInfo = res.data
				}
			})
		}
	},
	created() {
		this.getOnlineStatusData();
		this.getBindStatusData();
		this.getCompanyInfo();
	},
	mounted() {
		window.addEventListener("setItem", () => {
			this.districtData = sessionStorage.getItem("district") ?
				JSON.parse(sessionStorage.getItem("district")) : {};
			this.getOnlineStatusData();
			this.getBindStatusData();
			this.getCompanyInfo();
		});
	}

}
</script>


<style lang="scss" scoped>
.rightCon {
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	.subTitle {
		color: #fff;
		width: 100%;
		height: 50px;
		line-height: 50px;
		padding-left: 20px;
		background-image: url('../assets/subTitle.png');
		background-size: 100% 100%;
		letter-spacing: 6px;
		font-weight: 600;
		font-family: 'FZLTTHK--GBK1-0', 'FZLTTHK--GBK1';
	}
	.connectStatus {
		flex: 2;
		.elvChartStatus {
			width: 100%;
			height: calc(100% - 50px);
			display: flex;
			justify-content: space-around;
			.elvStatus {
				width: 50%;
				display: flex;
				flex-direction: column;
				justify-content: space-around;
				.chartDes {
					display: flex;
					.chartDesNum {
						width: calc(100% - 80px);
						display: flex;
						flex-direction: column;
						margin-left: 10px;
						justify-content: center;
						.chartDesFont {
							font-size: 12px;
						}
						.chartDesNumber {
							font-size: 26px;
						}
					}
				}
			}
			#elvChart {
				width: 50%;
				height: 100%;
			}
		}
	}

	.bindStatus {
		flex: 2;
		margin-bottom: 20px;
		.bindRatio {
			height: calc(100% - 50px);
			padding-top: 20px;
			display: flex;
			flex-direction: column;
			justify-content: space-around;
			.ratioNum {
				font-size: 14px;
				display: flex;
				justify-content: space-between;
			}
			.ratioLine {
				display: flex;
				width: 100%;
				.circle {
					margin-top: -3px;
					width: 10px;
					height: 10px;
					border-radius: 50%;
					filter: blur(1px);
				}
				.bindLine {
					display: flex;
					justify-content: flex-end;
					height: 4px;
					background: linear-gradient(
						90deg,
						rgba(0, 221, 253, 0) 0%,
						#00b8fa 100%
					);
					.bindCircle {
						@extend .circle;
						background-color: #00b8fa;
						margin-right: -1px;
					}
				}
				.unBindLine {
					display: flex;
					justify-content: flex-start;
					height: 4px;
					background: linear-gradient(
						270deg,
						rgba(255, 167, 0, 0) 0%,
						#fe6e00 100%
					);
					.unBindCircle {
						@extend .circle;
						background-color: #fe6e00;
						margin-left: -1px;
					}
				}
			}
		}
		.elvBind {
			display: flex;
			padding-top: 20px;
			.elvNum {
				height: 75px;
				flex: 1;
				display: flex;
				justify-content: center;
				align-items: center;
				text-align: center;
				img {
					width: 22px;
					height: 26px;
					margin-right: 15px;
				}
				.bindDes {
					text-align: left;
				}
				.bindLabel {
					font-size: 12px;
					color: #fff;
				}
			}
			.bindElvNum {
				margin-right: 20px;
				color: #00b8fa;
				font-size: 24px;
				background: url('../assets/bindBgc.png') no-repeat;
			}
			.unBindElvNum {
				background: url('../assets/bindBgc.png') no-repeat;
				color: #fe6e00;
				font-size: 24px;
			}
		}
	}
	.customerInfo {
		flex: 2;
		.customer {
			padding-top: 20px;
			display: flex;
			justify-content: space-between;
			& > div {
				flex: 1;
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
			}
			.customerName {
				color: #92a7b1;
				font-size: 12px;
				margin-top: 5px;
			}
			.weibaoNum {
				color: #00bcff;
				font-size: 26px;
			}
			.wuyeNum {
				color: #ff6b00;
				font-size: 26px;
			}
			.communityNum {
				color: #2162b3;
				font-size: 26px;
			}
		}
	}
	.timeContainer {
		flex: 1;
		margin-top: 10px;
	}
}
</style>